import { FC, Fragment, useEffect } from 'react';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Types
import QuizTypes from 'types/QuizTypes';
// Async
import { getIpInfo } from 'store/player/playerAsync';
// Actions
import { setInitialState } from 'store/player/playerSlice';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
// Dialog
import PromoVideoDialog from 'dialogs/PromoVideo.dialog';
// Hooks
import useToggle from 'hooks/useToggle';
// Components
import Countdown from 'components/Countdown';
import Prizes from 'components/Prizes';
import BannerImage from 'components/BannerImage';

// 
import MastheadImage from './MastheadImage';
import ButtonPlayNow from './ButtonPlayNow';
import LandingPage from './LandingPage';
import PoweredBy from 'components/PoweredBy';
import LanguageSelect from 'components/LanguageSelect';
import HomeTitles from './HomeTitles';


const StartPage:FC = () => {
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const quiz = useAppSelector(selectQuiz);

  const { open, toggle } = useToggle();

  useEffect(() => {
    // Clear all player data
    dispatch(setInitialState());
    dispatch(getIpInfo());

    if ( quiz.promoVideo ) toggle();
    // eslint-disable-next-line
  }, []);

  const isPollType = quiz?.type === QuizTypes.Poll;

  return (
    <Fragment>
      {!isPollType ? <MastheadImage mastheadImageUrl={quiz.mastheadImage} /> : null}
      <div
        className={`flex flex-col flex-1 p-4 ${isPollType ? 'pt-8' : ''}`}
        style={{ background: isPollType && quiz.homeScreenBackgroundImage ? `url('${quiz.homeScreenBackgroundImage}') center / cover` : '' }}
      >
        {quiz.quizNameVisible && !isPollType ? (
          <div>
            <h1 className={`mb-4 font-bold ${isPollType ? 'text-3xl text-[#164784] uppercase' : 'text-lg'} text-center`}>
              {quiz.displayName || quiz.quizName}
            </h1>
          </div>
        ) : null}
        <HomeTitles />
        <ButtonPlayNow />
        <Countdown />
        <LandingPage />
        <Prizes />
        <div className="flex-1" />
        <div className="flex justify-center">
          <LanguageSelect />
        </div>
        <PoweredBy />
      </div>
      {!isPollType ? <BannerImage /> : null}
      {/* Promo video */}
      {open ? <PromoVideoDialog onClose={toggle} /> : null}
    </Fragment>
  )
}

export default StartPage;
